// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmployeeAutopayPropertiesDto
 */
export interface IEmployeeAutopayPropertiesDto {
    /**
     * 
     * @type {string}
     * @memberof IEmployeeAutopayPropertiesDto
     */
    claim_autopay_type?: IEmployeeAutopayPropertiesDtoClaimAutopayTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeAutopayPropertiesDto
     */
    default_claim_payee_type?: IEmployeeAutopayPropertiesDtoDefaultClaimPayeeTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IEmployeeAutopayPropertiesDtoClaimAutopayTypeEnum {
    AUTO = 'AUTO',
    CLICK = 'CLICK'
}
/**
* @export
* @enum {string}
*/
export enum IEmployeeAutopayPropertiesDtoDefaultClaimPayeeTypeEnum {
    PARTICIPANT = 'PARTICIPANT',
    PROVIDER = 'PROVIDER',
    EMPLOYEE_CHOICE = 'EMPLOYEE_CHOICE'
}


/**
 * Check if a given object implements the IEmployeeAutopayPropertiesDto interface.
 */
export function instanceOfIEmployeeAutopayPropertiesDto(value: object): value is IEmployeeAutopayPropertiesDto {
    return true;
}

export function IEmployeeAutopayPropertiesDtoFromJSON(json: any): IEmployeeAutopayPropertiesDto {
    return IEmployeeAutopayPropertiesDtoFromJSONTyped(json, false);
}

export function IEmployeeAutopayPropertiesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeAutopayPropertiesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_autopay_type': json['claim_autopay_type'] == null ? undefined : json['claim_autopay_type'],
        'default_claim_payee_type': json['default_claim_payee_type'] == null ? undefined : json['default_claim_payee_type'],
    };
}

export function IEmployeeAutopayPropertiesDtoToJSON(json: any): IEmployeeAutopayPropertiesDto {
    return IEmployeeAutopayPropertiesDtoToJSONTyped(json, false);
}

export function IEmployeeAutopayPropertiesDtoToJSONTyped(value?: IEmployeeAutopayPropertiesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_autopay_type': value['claim_autopay_type'],
        'default_claim_payee_type': value['default_claim_payee_type'],
    };
}

